import { useState } from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import { useNewVersionAvailable } from './useNewVersionAvailable';

/**
 * Colours come from the KONE palette variables in theme.css. The global
 * `.MuiPaper-root` rule there forces a white background with `!important`
 * (the snackbar is a Paper), so the banner has to override it the same way;
 * `&&` doubles the class to win on specificity regardless of stylesheet order.
 * White on KONE Blue and KONE Blue on white both have a contrast ratio of
 * about 6:1.
 */
const useStyles = makeStyles({
  content: {
    '&&': {
      background: 'var(--kone-blue) !important',
      color: 'var(--kone-white) !important',
      border: '1px solid var(--kone-blue) !important',
    },
  },
  reload: {
    backgroundColor: 'var(--kone-white)',
    color: 'var(--kone-blue)',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'var(--kone-sand)',
    },
  },
  later: {
    color: 'var(--kone-white)',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
});

/**
 * Tells the user when a new version of KSDP has been deployed and lets them
 * choose when to reload. It never reloads the page by itself, so nobody loses
 * a half-filled form.
 */
export function AppUpdateNotification() {
  const classes = useStyles();
  const updateAvailable = useNewVersionAvailable();
  const [dismissed, setDismissed] = useState(false);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={updateAvailable && !dismissed}
      message="A new version of KSDP is available. Reload to get the latest changes."
      ContentProps={{ classes: { root: classes.content } }}
      action={
        <>
          <Button
            className={classes.reload}
            size="small"
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
          <Button
            className={classes.later}
            size="small"
            onClick={() => setDismissed(true)}
          >
            Later
          </Button>
        </>
      }
    />
  );
}
